import { writable } from "svelte/store";


const initialState =   {
    dialogOpen: false,
    function: null,
    loading:false,
    label:null,
    module:null,
    title: null,
    data: [],
}
const  { subscribe, set, update } = writable(initialState);

 export default {
    subscribe,
    update(newState){
         update((s)=>{
            return {...s,...newState}
         })
    },
    close(){
        set(initialState)
    },
    open(data){
      set({...data, loading:false, dialogOpen:true})
    },
    openDeletePrompt(module,data,onApproved){
       set({
        function:onApproved,
        module,
        title:'Delete Item?',
        data,
        loading:false,
        dialogOpen:true
       })
    }
    
    
 }

